import { useState, useEffect } from "react";


const useAltoVisible = () => {
    const [medida, setMedida] = useState(() => ({
        alto: window.visualViewport?.height || window.innerHeight,
        top: window.visualViewport?.offsetTop || 0,
    }));

    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return undefined;
        const actualizar = () => setMedida({ alto: vv.height, top: vv.offsetTop });
        vv.addEventListener("resize", actualizar);
        vv.addEventListener("scroll", actualizar);
        return () => {
            vv.removeEventListener("resize", actualizar);
            vv.removeEventListener("scroll", actualizar);
        };
    }, []);

    return medida;
};

export default useAltoVisible;
